var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('KIcon',{staticClass:"icon",attrs:{"icon":"helpOutline"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }